export const TITLE = "E-Trio 3 Wheeler Price in India 2026 | Etrio Electric Auto";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Etrio electric three wheeler price in India ranges from ₹3.9 - ₹4.4 Lakh. Explore Etrio commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    name: "keywords",
    content:
      "Etrio electric auto, Etrio 3 wheeler, Etrio electric vehicles, Etrio three wheeler, Etrio electric auto price, Etrio commercial vehicles, Etrio EV auto, Etrio electric truck, Etrio Touro Max, Etrio Touro Max+, Etrio Touro Max++, Etrio price in India, Etrio dealers, Etrio specifications, Etrio features, Etrio battery capacity, Etrio range, Etrio charging, Etrio EMI, Etrio financing, Etrio test drive, E-trio 3 wheelers",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "E-Trio 3 Wheeler Price in India 2026 | Etrio Electric Auto",
  },
  {
    property: "og:description",
    content:
      "Etrio electric three wheeler price in India ranges from ₹3.9 - ₹4.4 Lakh. Explore Etrio commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Etrio electric three wheeler price in India ranges from ₹3.9 - ₹4.4 Lakh. Explore Etrio commercial vehicles, mileage, images, features & on-road prices.",
  },
  {
    name: "twitter:title",
    content: "E-Trio 3 Wheeler Price in India 2026 | Etrio Electric Auto",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Etrio",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Etrio";

export const H1_HEADING = "Etrio Electric Auto: The Future of Smart Commercial Mobility";

export const ATF_CONTENT = {
  text: [
    "As the race for becoming the best Electric auto is on, Etrio Motors is slowly emerging as a trailblazer in the Indian EV space. The company is now quite specialised in the design and manufacturing of highly efficient Etrio electric 3 wheelers and other last-mile logistics solutions for Indian cities and towns. Etrio is evolving in the electric three wheeler landscape by blending data-driven engineering with robust designs. Etrio provides an Etrio electric commercial vehicle lineup that reduces operational costs while maximising uptime for logistics and last-mile connectivity businesses.",
    "If you are searching for an Etrio electric auto showroom near me or comparing the latest Etrio electric auto price, we provide the most business-friendly deals in India, along with a lot of supporting offers to ensure scale and profitability.",
    "To help you choose the right Etrio electric 3 wheeler for your business needs, here is a detailed comparison of the latest models available at Turno.",
  ],
};

export const ATF_NOTE =
  "Note: *Ex-showroom price. On-road price varies by RTO, insurance, and state subsidies.";

export const ATF_TABLE_HEADING = "Etrio Motors Price List in India 2026";

export const ATF_TABLE_COLUMNS = [
  { key: "model", label: "Etrio Electric 3 Wheeler Model" },
  { key: "payload", label: "Payload (kg)" },
  { key: "topSpeed", label: "Top Speed" },
  { key: "range", label: "Max Range" },
  { key: "price", label: "Price Range (Ex-showroom)" },
];

export const ATF_TABLE_DATA = [
  { model: "Etrio Touro MAX++", payload: "550 kg", topSpeed: "50 kmph", range: "100 km", price: "₹4.10 Lakh*", link: "/electric-commercial-vehicles/Etrio/Touro-MAX" },
];

export const SEO_FOOTER_CONTENT = [
  {
    heading: "About Etrio Electric Auto Price",
    paragraphs: [
      "The Etrio electric auto on-road price typically includes the ex-showroom price of the vehicle, RTO registration, insurance, and the Etrio electric auto charger price. When compared to the traditional autos, which run on diesel, petrol or CNG, the initial investment is higher on electric autos, but the gains are massive. Therefore, fleet owners save a lot on operating costs, which include fuel and maintenance, and Etrio Autos ensures that it pays for itself within 18 to 24 months of continuous operations.",
      "For those looking to electrify existing fleets of diesel or CNG autos, the Etrio conversion kit cost remains a viable alternative for specialised applications.",
    ],
  },
  {
    heading: "Etrio Cargo Electric Autos",
    list: [
      {
        label: "Etrio Touro MAX++",
        text: "Price: ₹4.10 Lakh (Ex-showroom). Features: Equipped with high-capacity battery that offers a certified range of 100 km, a 550 kg payload capacity, and a digital instrument cluster. It features regenerative braking and a rust-proof cargo body designed for last-mile delivery.",
      },
    ],
  },
  {
    heading: "Etrio Electric 3 Wheeler Insights",
    list: [
      {
        label: "Customizable Cargo",
        text: "The Touro MAX++ comes with various load body options to suit e-commerce, logistics, water delivery, or waste management.",
      },
      {
        label: "Charging Infrastructure",
        text: "The electric auto can be fully charged overnight with the help of a standard 15A socket, making it independent of expensive fast-charging hubs.",
      },
      {
        label: "Conversion Heritage",
        text: "While focusing on new builds, the company's expertise in the Etrio electric car conversion kit market has influenced its robust powertrain reliability.",
      },
      {
        label: "Network Growth",
        text: "Finding an Etrio EV dealership near me is becoming easier as the brand is slowly expanding across Tier 1 and Tier 2 cities in India. Turno is a one-stop shop for your electric vehicle purchase that includes electric autos from Etrio.",
      },
    ],
  },
];

export const BRAND_HEADER_INFO = "E-trio 3 Wheeler";

export const BRAND_DESCRIPTION = "Join us in our effort to build a pollution-free and sustainable transportation system in India with E trio 3 Wheeler. You can try the Etrio Touro Max+ or the Etrio Touro Max++ : both efficient electric three wheelers at affordable prices. These Etrio electric vehicles (EVs) come with reduced running costs, greater battery life, and unmatched warranty. So, stop thinking and switch to electric today.";

export const PRICE_LIST_HEADER = "E-trio Electric Auto Price List in India 2026";

export const PRICE_LIST_DESCRIPTION = "Now get sustainable, eco-friendly, and efficient transportation with our Etrio electric auto models. Take a look at these pocket-friendly prices below, and pick your Etrio electric auto according to your business requirement and budget.";

export const PROMISES_HEADER = "Why Etrio Electric Vehicles from Turno?";

export const ADVANTAGES_HEADING = "Advantages of Etrio Electric Auto";

export const ADVANTAGES_DESCRIPTION = "Etrio electric commercial vehicles deliver powerful performance, intelligent technology, and pocket-friendly options. Here are the key benefits:";

export const HIGHLIGHTS_HEADING = "Highlights of Etrio EV Auto:";

export const HIGHLIGHTS_DESCRIPTION = "Etrio EV Auto is an efficient and eco-friendly three-wheeler with an advanced battery that can last up to 157 kilometers on a single charge. It features regenerative hydraulic braking, which helps to conserve energy and extend the battery life. Etrio EV Auto is also easy to operate with comfortable seats and ample storage space.";

export const BLOG_HEADER = "Turno Blogs on Etrio 3 Wheeler";

export const ABOUT_HEADING = "About Etrio Electric Auto:";

export const ABOUT_DESCRIPTION = "Etrio offers a wide range of electric vehicles, including three-wheelers and commercial vehicles. The company's vehicles are designed to be both eco-friendly and affordable, and they are well-suited for use in urban and rural areas. Etrio has a strong focus on innovation, and the company is constantly developing new technologies to improve the performance and efficiency of its vehicles. Etrio is also committed to providing uninterrupted customer service across the country.";

export const MODELS_HEADER = "Etrio Electric Commercial Models & Range:";

export const MODELS_DESCRIPTION = "Etrio Electric EV has a range of vehicles that are designed to meet the needs of different users. Here are the two electric auto models that Etrio offers:";

export const DEALER_HEADER = "Etrio EV Dealers Near Me:";

export const DEALER_DESCRIPTION = "With a growing number of people embracing Etrio's top-notch mobility solutions that offer unmatched value for money, Turno presents an exceptional range of Electric Trucks at budget-friendly prices. Don't wait any longer – secure your Etrio electric vehicle with Turno today and drive towards extraordinary savings and a more efficient future.";

export const FAQ_HEADING = "FAQs on Etrio Electric Auto";

export const LOAN_HEADER = "E trio 3 Wheeler loan";

export const CTA_TEXT = "Get On Road Price";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const AVAILABLE_BRANDS_TITLE = "Available Brands";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Etrio" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Etrio",
      item: VEHICLE_LINK,
    },
  ],
};